import { X } from "lucide-react";

interface RealtimePausedBannerProps {
  onReconnect: () => void;
  onDismiss: () => void;
  /** Prefix for data-testid attributes (e.g. "matches", "chat"). */
  testIdPrefix: string;
}

/**
 * Non-blocking notice when a Firestore snapshot listener has died.
 * Keeps the underlying list/conversation visible.
 */
export function RealtimePausedBanner({ onReconnect, onDismiss, testIdPrefix }: RealtimePausedBannerProps) {
  return (
    <output
      className="mx-4 mt-3 flex items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-950"
      data-testid={`${testIdPrefix}-realtime-paused-banner`}
    >
      <p className="min-w-0 flex-1 font-mono">
        Live updates paused.{" "}
        <button
          type="button"
          onClick={onReconnect}
          className="font-semibold underline underline-offset-2 hover:text-amber-800"
          data-testid={`${testIdPrefix}-realtime-reconnect`}
        >
          Reconnect
        </button>
      </p>
      <button
        type="button"
        onClick={onDismiss}
        className="shrink-0 rounded p-1 text-amber-800 hover:bg-amber-100"
        aria-label="Dismiss"
        data-testid={`${testIdPrefix}-realtime-dismiss`}
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </output>
  );
}
